import MobileRedirectScreen from "../MobileRedirectScreen";
import {Outlet} from "react-router";
import {useEffect, useState} from "react";

export default function MetaLayoutScreen() {
    // Used in index.js as a global layout, making mobile redirection
    // available for all routes

    // PROPERTIES
    const [isMobile, setIsMobile] = useState(false);

    // HOOKS
    // ---- At rendering : Add event listener on screen size
    useEffect(() => {
        updateIsMobile();
        window.addEventListener("resize", updateIsMobile);
        return () => window.removeEventListener("resize", updateIsMobile);
    }, []);

    // METHODS
    // ---- UI : Check if is mobile
    function updateIsMobile() {
        setIsMobile(window.innerWidth <= 640);
    }

    // BUILD
    return (
        <div className="App">
            <header className="App-header">
                {isMobile ? <MobileRedirectScreen /> : <Outlet />}
            </header>
        </div>
    );
}